import { getData } from "../resources"
import logo from "../assets/Logo.png";
import { Button, message } from "antd";


export const EncuestaLoading = () => <div style={{ paddingTop: 180 }}>
    <div style={{ margin: 'auto', width: '40%', textAlign: 'center' }}>
        <h3 >Cargando</h3>
    </div>
</div>

export function checkEncuesta(id_usuario, visita, tipo, sesion, protocolo, setPacienteData, idmedico, setMedicoData, setEncuestaNotExists, setChecking) {

    console.log(id_usuario, visita, tipo, sesion, protocolo)
    console.log(idmedico)
    getData('getuser/' + id_usuario).then((rs) => { setPacienteData(rs) })
    getData('getuser/' + idmedico).then((rs) => { setMedicoData(rs) })


    getData(`encuestas/find/${id_usuario}/${visita}/${tipo}/${sesion}/${protocolo}`).then(rs => {
        console.log('Response at find ', rs);
        setEncuestaNotExists(rs.message && rs.message === 'The survey does not exist')
    }).then(() => { setChecking(false) })
}



export const ThanksMessage = ({ nextUrl, scaleName = "" }) => {
    return <div style={{ padding: '60px 16px' }}>
        <div style={{ margin: 'auto', width: '100%', maxWidth: 480, textAlign: 'center', flexDirection: 'column', display: 'flex', gap: 20 }}>
            <h3>Gracias por contestar la escala {scaleName}</h3>
            <img src={logo} alt="recreamedLogo" style={{ margin: 'auto', width: '100%', maxWidth: 256 }} />
            {nextUrl && <Button type="primary" onClick={() => window.location.href = nextUrl} style={{ marginTop: 20 }}>Siguiente</Button>}
        </div>
    </div>
}

export function getNextSurveyUrl(currentTipo, chain, idmedico, idpaciente, token, visita, session, protocolo) {
    if (!chain) return null;
    const surveys = chain.split(',');
    const idx = surveys.indexOf(currentTipo);
    if (idx === -1 || idx >= surveys.length - 1) return null;
    const next = surveys[idx + 1];
    return `/${next}_public/${idmedico}/${idpaciente}/${token}/${visita}/${session}/${protocolo}?chain=${chain}`;
}

export const onFinishFailed = (errorInfo) => {
    errorInfo.errorFields.map((p) => {
        message.error('Conteste la pregunta ' + p.name)
    })
};

export const CardHeader = ({ title, children }) => {
    return <div style={{ backgroundColor: 'white', padding: 20, borderRadius: 10, marginBottom: 20, display: 'flex', flexDirection: 'column', gap: 10 }}>
        {title && <h2 style={{ margin: 0 }}>{title}</h2>}
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 10 }}>
            {children}
        </div>
    </div>
}

export const InfoCard = ({ label, value }) => {
    return <div className="blued" style={{ padding: 12, borderRadius: 10, display: 'flex', flexDirection: 'column', }}>
        <span style={{ color: '#fff', fontSize: 16 }}>{label}</span>
        <span style={{ color: '#fff', fontWeight: 'bold', fontSize: 16 }}>{value}</span>
    </div>
}

export const NameLabel = ({ pacienteData, label = "Paciente: " }) => {
    return <div className="blued" style={{ padding: 12, borderRadius: 10, display: 'flex', flexDirection: 'column', }}>
        <span style={{ color: '#fff', fontSize: 16 }}>{label}</span>
        <span style={{ color: '#fff', fontWeight: 'bold', fontSize: 16 }}>{pacienteData.name} {pacienteData.apellido}</span>
    </div>
}